module.exports = __webpack_public_path__ + "img/BAT-icon.3a412d9.png";